import { render, staticRenderFns } from "./Pagetop.vue?vue&type=template&id=5ed91ac4&scoped=true&"
import script from "./Pagetop.vue?vue&type=script&lang=js&"
export * from "./Pagetop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed91ac4",
  null
  
)

export default component.exports